const usdcContracts: Record<number, string> = {
  4337: '0x76BF5E7d2Bcb06b1444C0a2742780051D8D0E304', // beam
  13337: '0x007Fdc86FD12924C9116025C7F594843087397E3', // beam testnet
  13371: '0x6de8aCC0D406837030CE4dd28e7c08C5a96a30d2', // immutable zkEvm
  13473: '0x3B2d8A1931736Fc321C24864BceEe981B11c3c57', // immutable zkEvm testnet
  50104: '0x0f5450df41ea983f4de1de52dd9246e6142be411', // sophon
  531050104: '0x155F5f62Ae114a46aF924FAe3a9b994849076403', // sophon testnet
};

export default usdcContracts;
